module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-129.9023cf99.svg";